import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "relationship"]

  connect() {
    this.showAllRelationships()
  }

  showType(event) {
    const relationshipType = event.currentTarget.getAttribute('data-relationship-type')
    
    // Update tab styles
    this.tabTargets.forEach(tab => {
      tab.classList.remove('border-blue-500', 'text-blue-600')
      tab.classList.add('border-transparent', 'text-gray-500')
    })
    event.currentTarget.classList.remove('border-transparent', 'text-gray-500')
    event.currentTarget.classList.add('border-blue-500', 'text-blue-600')
    
    // Show/hide relationships
    this.relationshipTargets.forEach(relationship => {
      const type = relationship.getAttribute('data-relationship-type')
      if (type === relationshipType) {
        relationship.classList.remove('hidden')
      } else {
        relationship.classList.add('hidden')
      }
    })
  }

  showAllRelationships() {
    // Reset tab styles
    this.tabTargets.forEach(tab => {
      tab.classList.remove('border-blue-500', 'text-blue-600')
      tab.classList.add('border-transparent', 'text-gray-500')
    })
    
    // Show all relationships
    this.relationshipTargets.forEach(relationship => {
      relationship.classList.remove('hidden')
    })
  }
}
